import { useReaderLine } from "../../hooks/useReaderLine";
import { useReaderBridge } from "../../hooks/useReaderBridge";

const STATES = {
  listening: ["text-emerald-300", "bg-emerald-400 animate-pulse", "Listening"],
  bridge: ["text-emerald-300", "bg-emerald-400 animate-pulse", "Listening · reader bridge online"],
  nofocus: ["text-amber-300", "bg-amber-400", "Screen not focused - click anywhere"],
  paused: ["text-slate-400", "bg-slate-500", "Paused"],
};

const time = (ts) => new Date(ts).toLocaleTimeString([], { hour12: false });

export const ReaderLine = ({ onScan, enabled, lastRead }) => {
  const { inputProps, keys, docFocus } = useReaderLine(onScan, { enabled, captureGlobal: true });
  const bridge = useReaderBridge(onScan, { enabled });
  const state = !enabled ? "paused" : bridge.online ? "bridge" : docFocus ? "listening" : "nofocus";
  const [color, dot, label] = STATES[state];

  return (
    <section data-testid="reader-line" className="border border-cyan-400/20 bg-slate-950/70 p-4 font-mono">
      <div className="flex items-center justify-between gap-3">
        <span className="lab-label">Reader line // USB NFC</span>
        <span data-testid="reader-line-status" data-state={state} className={`flex items-center gap-2 text-xs uppercase tracking-widest ${color}`}>
          <span className={`h-2 w-2 rounded-full ${dot}`} /> {label}
        </span>
      </div>
      <label className="mt-3 flex items-center gap-3 border-b border-cyan-400/40 pb-2 text-cyan-300">
        <span className="text-lg">&gt;</span>
        <input
          data-testid="nfc-scanner-input"
          {...inputProps}
          autoFocus
          autoComplete="off"
          spellCheck={false}
          aria-label="NFC reader input"
          placeholder="waiting for tag..."
          className="w-full bg-transparent text-lg tracking-[0.2em] text-cyan-200 outline-none placeholder:text-slate-600"
        />
      </label>
      <div className="mt-3 flex flex-wrap justify-between gap-2 text-xs tracking-widest text-slate-500">
        <span data-testid="reader-last-read">
          LAST READ: {lastRead ? `${lastRead.uid} -> ${lastRead.result} @ ${time(lastRead.at)}` : "NONE"}
        </span>
        <span data-testid="reader-key-count">KEYS RX: {keys}{bridge.lastPush ? ` · BRIDGE: ${bridge.lastPush.uid}` : ""}</span>
      </div>
    </section>
  );
};
